import styled from "styled-components";

export const Container = styled.div`
  margin-left: auto;
`;

export const ButtonContainer = styled.div<{
  isActive: boolean;
}>`
  border-radius: 2px;
  background-color: ${({ theme, isActive }) =>
    isActive
      ? theme.colorTokens.component.button.buttonLink.background.active
      : "transparent"};
`;
